
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/purolator/ship-now",
      function () {
        return require("private-next-pages/partners/purolator/ship-now.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/purolator/ship-now"])
      });
    }
  